import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './css/About.css';

export default function About() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div className="about-section">
        <div className="about-card">
          <h2 className="about-title">ABOUT THE SCHOOL</h2>
          <div className="about-title-underline"></div>

          <div className="about-row">
            <div className="about-content-col">
              <p className="about-text">
                From the very beginning of the past century, Adra, anciently called
                Aradhya Nagari, was gradually flourishing as a railway town. People
                from different parts of the country came to this place to join the
                railways. A new socio-economic clan emerged with differences in caste,
                creed, language, religious belief, and culture. A need for a separate
                school for girls was felt by Sri Kanti Das. Accordingly, in a thatched
                house adjacent to the present building, a school was set up. Later in
                the year 1926, the then B N Railway took all the financial and
                administrative responsibilities of this school.&nbsp;
                <Link to="/aboutus" className="about-link">read more...</Link>
              </p>
            </div>

            <div className="about-image-col">
              <img
                src="/images/IMG_0312.jpg"
                alt="School"
                className="about-img"
                onClick={() => setModalOpen(true)}
                tabIndex={0}
                style={{ cursor: 'zoom-in' }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Modal for large image */}
      {modalOpen && (
        <div className="about-modal" onClick={() => setModalOpen(false)}>
          <div className="about-modal-content" onClick={(e) => e.stopPropagation()}>
            <img
              src="/images/IMG_0312.jpg"
              alt="School Large"
              className="about-modal-img"
            />
            <button className="about-modal-close" onClick={() => setModalOpen(false)}>
              &times;
            </button>
          </div>
        </div>
      )}
    </>
  );
}
